import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/layout/Header';
import PrimaryBox from '../../components/layout/PrimaryBox';
import PeriodReportsTable from '../../components/tables/operations/reporting/PeriodReportsTable';
import ReportingNeeds from '../../components/tables/operations/reporting/ReportingNeeds';
import CustomTabs from '../../components/ui/CustomTabs';
import { localStorageKeys } from '../../constants';
import { usePageTitle } from '../../hooks/usePageTitle';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import { getTomorrowDate, isSameDayOrAfter, isSameDayOrBefore } from '../../utils/dates';
import { getItemFromLocalStorage, storeItemToLocalStorage } from '../../utils/localStorage';

const ReportingPage: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState(parseInt(getItemFromLocalStorage(localStorageKeys.TAB.REPORTING) || '0'));
    const { t } = useTranslation();
    usePageTitle(capitalizeFirstLetter(t('reporting')));
    const [firstDate, setFirstDate] = useState(new Date(getItemFromLocalStorage(localStorageKeys.REPORTINGSTARTDATE) || new Date()));
    const [secondDate, setSecondDate] = useState(new Date(getItemFromLocalStorage(localStorageKeys.REPORTINGENDDATE) || getTomorrowDate()));

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setSelectedTab(newValue);
        storeItemToLocalStorage(localStorageKeys.TAB.REPORTING, newValue.toString());
    };

    const handleFirstDateChange = (newDate: string) => {
        const tmpDate = new Date(newDate);
        if (!isSameDayOrBefore(tmpDate, secondDate)) return;
        setFirstDate(tmpDate);
        storeItemToLocalStorage(localStorageKeys.REPORTINGSTARTDATE, newDate);
    };

    const handleSecondDateChange = (newDate: string) => {
        const tmpDate = new Date(newDate);
        if (!isSameDayOrAfter(tmpDate, firstDate)) return;
        setSecondDate(tmpDate);
        storeItemToLocalStorage(localStorageKeys.REPORTINGENDDATE, newDate);
    };

    return (
        <PrimaryBox>
            <Header
                title={t('operations')}
                breadcrumbs={[{ label: capitalizeFirstLetter(t('dashboard')) + ' (' + t('beta') + ')' }]}
                subTitle={capitalizeFirstLetter(t('dashboard')) + ' (' + t('beta') + ')'}
                isSecondDateVisible
                initialDate={firstDate}
                onDateChange={(newDate) => handleFirstDateChange(newDate.toISOString())}
                initialSecondDate={secondDate}
                onSecondDateChange={(newDate) => handleSecondDateChange(newDate.toISOString())}
                shortDate
                shortSecondDate
            ></Header>
            <CustomTabs selectedTab={selectedTab} handleTabChange={handleTabChange} tabLabels={[t('reports'), t('needs')]} />
            {selectedTab === 0 && <PeriodReportsTable startDate={firstDate} endDate={secondDate} />}
            {selectedTab === 1 && <ReportingNeeds startDate={firstDate} endDate={secondDate} />}
        </PrimaryBox>
    );
};

export default ReportingPage;
